export default __webpack_public_path__ + "static/media/graduation-cap.f96a0579.svg";